import webBiLogger from '@wix/web-bi-logger';
import {
  docsAiAssistantOpenCloseSrc112Evid1435,
  docsAiAssistantClickSrc112Evid13,
  docsAiAssistantAnswerSrc112Evid14,
  docsAiAssistantCostSrc112Evid1436,
} from '@wix/bi-logger-api-infra-data/v2';
import { Logger } from '@wix/web-bi-logger/dist/src/types';
import { v4 } from 'uuid';

interface ExternalLogger {
  debug?: (message: string, data: any) => void;
  info?: (message: string, data: any) => void;
  warn?: (message: string, data: any) => void;
  error?: (message: string, data: any) => void;
}

export class DIGORBI {
  openTime = Date.now();
  logger: Logger;
  sessionId: string;

  constructor(
    private portal?: string,
    private pageUrl?: string | null,
    private loggerInstance?: Logger | null | undefined,
    private externalLogger?: ExternalLogger | null | undefined
  ) {
    this.logger =
      this.loggerInstance || loggerInstance || webBiLogger.factory().logger();
    this.sessionId = v4();
  }

  open() {
    this.openTime = Date.now();
    this.logger.report(
      docsAiAssistantOpenCloseSrc112Evid1435({
        action: 'open',
        portal: this.portal,
        page_url: window.location.href,
        ai_session_id: this.sessionId,
      })
    );
  }

  close() {
    this.logger.report(
      docsAiAssistantOpenCloseSrc112Evid1435({
        action: 'close',
        portal: this.portal,
        page_url: this.pageUrl || window.location.href,
        interaction_time: Date.now() - this.openTime,
        ai_session_id: this.sessionId,
      })
    );
  }

  click(cta: string, data?: any) {
    this.logger.report(
      docsAiAssistantClickSrc112Evid13({
        cta,
        portal: this.portal,
        page_url: this.pageUrl || window.location.href,
        ai_session_id: this.sessionId,
        extra_values: JSON.stringify(data || {}),
      })
    );
  }

  answer(question: string, answer: string) {
    this.externalLogger?.debug?.('digor-answer', {
      question,
      answer,
    });

    this.logger.report(
      docsAiAssistantAnswerSrc112Evid14({
        question,
        answer,
        portal: this.portal,
        page_url: this.pageUrl || window.location.href,
      })
    );
  }

  metric(type: string, cost?: string | number | null, time?: number | null) {
    if (!cost || !time) {
      return;
    }

    const costNumber = typeof cost === 'string' ? parseFloat(cost) : cost;

    this.externalLogger?.debug?.('metric', {
      type,
      cost: costNumber,
      time,
      logger: typeof this.logger,
    });

    this.logger?.report(
      docsAiAssistantCostSrc112Evid1436({
        cost: costNumber,
        response_time: time,
        type,
      })
    );
  }
}

/*
# grafana trino queries:


## clicks:

SELECT
    $__timeFrom() AS timex,
    cta,
    count(cta) AS count_cta
FROM
    events.dbo.users_112
WHERE
    evid = 13 AND
    uuid != 'e6a89eda-d100-4b2d-8a47-3040e2134497' AND
    date_created BETWEEN $__timeFrom() AND $__timeTo()
GROUP BY
    cta

## cost 1 (sum all for time range) :

SELECT
    $__timeFrom() AS timex,  -- Use a consistent 'time' column name
    SUM(cost * 1.00 / 100000000) AS total_cost_dollar
FROM
    events.dbo.sites_112
WHERE
    evid = 1436 AND
    AND date_created BETWEEN $__timeFrom() AND $__timeTo()
GROUP BY
    1
ORDER BY
    1

## cost 2 graph per day for time range:


*/
